module.exports = __webpack_public_path__ + "img/locandina_dorina.7f082708.jpg";